// extracted by mini-css-extract-plugin
export default {"wrapper":"cecc35e5c0c5"};